import { FETCH_COMMENTS_START, FETCH_COMMENTS_SUCCESS } from '../actions/actiontypes';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_COMMENTS_START: {
      return {};
    }
    case FETCH_COMMENTS_SUCCESS: {
      return { ...state, data: action.payload };
    }
    default:
      return state;
  }
}